import styled from 'styled-components'
import { colors } from '../../../../styles/constants'
import Button from '../../../../components/Form/Button'
import Skeleton from 'react-loading-skeleton'

const CARD_BOX_SIZES = {
  title: {
    width: '190px',
    height: '19px',
    borderRadius: '8px',
    marginBottom: '4px'
  },
  subtitle: {
    width: '290px',
    height: '17px',
    borderRadius: '8px',
    marginBottom: '16px'
  },
  card: {
    width: '100%',
    height: '251px',
    borderRadius: '12px',
    marginBottom: '16px'
  }
}

export const Container = styled.div`
  margin: 0 16px 24px 16px;
  span {
    display: flex;
    margin-left: auto;
    margin-right: auto;
  }
`
export const InfoCard = styled.div`
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  color: ${colors.gray.dark};
`
export const CardWrapper = styled.div`
  margin: 24px 0;
`

export const CardBody = styled.div`
  width: 100%;
`

export const CardSection = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: ${({ justifyContent }) => justifyContent || 'start'};
    margin-bottom: 24px;
    h2 strong {
      ${({ isDisabled }) => isDisabled && 'color: #555555'};
    }
    :last-child {
    margin-bottom: 0;
  }
    svg {
      flex-shrink: 0;
      path {
        ${({ isDisabled }) => isDisabled && 'fill: #777777'};
      }
    }
`

export const CardTitle = styled.h2`
  font-family: 'Nunito';
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.96px;
  color: ${colors.gray.darker};
  margin-bottom: 4px;
  strong {
    font-size: 20px;
    color: ${colors.cyan.default};
    font-weight: 600;
    letter-spacing: 0.96px;
  }
`

export const CardSubtitle = styled.h3`
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: ${colors.gray.dark};
  margin-bottom: 0;
  strong {
    font-family: 'Open Sans';
    font-size: 14px;
    font-weight: 600;
  }
`

export const ActionButton = styled(Button)`
  width: 112px;
  margin-top: -8px;
`
export const SkeletonCard = styled(Skeleton)`
  width: ${({ type }) => CARD_BOX_SIZES[type].width ?? 'inherit'};
  height: ${({ type }) => CARD_BOX_SIZES[type].height ?? 'inherit'};
  border-radius: ${({ type }) => CARD_BOX_SIZES[type].borderRadius ?? '0'};
  margin-bottom: ${({ type }) => CARD_BOX_SIZES[type].marginBottom ?? '0'};
`
